import { Button, Typography, Link, Grid2 as Grid } from "@mui/material";
import { darken } from "@mui/material/styles";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { EmailContactModel } from "../../models/ContactModels";
import { Tip } from "../../components/Tip";
import { Footer } from "../../components/Footer";
import { ContactList } from "./ContactList";
import AssignButton from "../../components/AssignButton";
import ActionWithAi from "../../components/ActionWithAi";
interface Props {
  email: string;
  suppliers: EmailContactModel[];
  customers: EmailContactModel[];
}

export function MultiContactsMatched({ email, suppliers, customers }: Props) {
  const emailDomain = email.split("@")[1];
  const navigate = useNavigate();
  const [type, setType] = useState<"receivables" | "payables" | null>(null);

  const onViewSales = () => {
    if (!customers.length) return;

    if (customers.length === 1) {
      navigate(`/receivables/${customers[0].id}`);
    } else {
      setType("receivables");
    }
  };

  const onViewPurchases = () => {
    if (!suppliers.length) return;

    if (suppliers.length === 1) {
      navigate(`/payables/${suppliers[0].id}`);
    } else {
      setType("payables");
    }
  };

  const onBack = () => {
    setType(null);
  };

  if (type !== null) {
    return (
      <>
        <ContactList contacts={type === "receivables" ? customers : suppliers} type={type} />

        <Grid py={2} container justifyContent="space-between" width="100%">
          <ActionWithAi relatedIds={[]} />
          <AssignButton />
        </Grid>
      </>
    );
  }

  return (
    <>
      <Tip title="Multiple results">
        <Typography>
          The domain
          <Link href={`mailto:${email}`}>{` ${emailDomain} `}</Link>
          matches two types of accounts.
        </Typography>
        <Grid container={true} direction="column" spacing={1} mt={4} width="100%">
          <Grid size={12}>
            <Button fullWidth variant="contained" endIcon={<ArrowForwardIcon />} onClick={onViewSales}>
              View Sales
            </Button>
          </Grid>
          <Grid size={12}>
            <Button
              fullWidth
              variant="contained"
              endIcon={<ArrowForwardIcon />}
              onClick={onViewPurchases}
              sx={{ backgroundColor: "#36C7AA", "&:hover": { backgroundColor: darken("#36C7AA", 0.15) } }}
            >
              View Purchases
            </Button>
          </Grid>
        </Grid>
      </Tip>
      <Footer>
        <Grid container justifyContent="space-between" width="100%">
          <ActionWithAi relatedIds={[]} />
          <AssignButton />
        </Grid>
      </Footer>
    </>
  );
}
